import React from "react";

const TrademarkPolicy = () => {
  return (
    <div className="LegalsPage">
      <div className="trademark-policy">
        <h1 className="trademark-policy-heading">Trademark Policy</h1>
        <p>
          <i>Last updated: May 9, 2023</i>
        </p>

        <p>
          This Policy covers general rules for referring to yslearn and using
          trademarks, service marks, and logos that yslearn may license to you
          (collectively, “yslearn Marks”).
        </p>
        <p>The following is a non-exhaustive list of yslearn Marks:</p>
        <ol>
          <ul>
            <li>yslearn®</li>
            <li>Cudoo</li>
            <li>The Babb Group</li>
            <li>Professor’s services</li>
          </ul>
        </ol>
        <p>
          Trademark guidelines  for several yslearn Marks are linked below.
          yslearn reserves the right to change the terms of this Policy or any
          guidelines at any time, in its sole discretion, by posting the updated
          Policy or guidelines to the yslearn website. To ask any questions
          about this Policy or to report any unauthorized use of yslearn Marks,
          please email {" "}
          <a href="mailto:support@yslearn.in">support@yslearn.in</a>
        </p>

        <h2>General Rule: Permission Required</h2>

        <p>
          As a rule, a trademark license is required in order to use any yslearn
          Mark. Except for the three exceptions outlined below, this Policy does
          not count as “permission to use” any trademarks, and there are no
          “open source” pre-approved use cases. To request permission to use any
          yslearn Mark, please email{" "}
          <a href="mailto:support@yslearn.in">support@yslearn.in</a>
        </p>
        <h4>Exceptions</h4>
        <p>Without a separate trademark license:</p>

        <ul>
          <li>
            You may use yslearn Marks in text for the sole purpose of referring
            to or describing yslearn’s website, products, and services. For
            example: if you have a product or service that is compatible with
            the yslearn platform, you may use “ yslearn” to describe the
            compatibility, such as “runs on,” “for use on,” or “compatible with”
            the yslearn platform.
          </li>
          <li>
            If you use the yslearn platform:
            <ul>
              <li>
                you should add the “Powered by yslearn” logo in the footer of
                each page of your website, and the logo should include a live
                link to the<u> yslearn website.</u> See the{" "}
                <u>Powered by yslearn logo page</u> for variants of this logo
                and instructions on how to add it to your instance; and
              </li>
              <li>
                you may use the “Powered by yslearn” logo on any course
                certificates or other credentials issued in connection with your
                instance in accordance with the yslearn trademark guidelines
                linked below.
              </li>
            </ul>
          </li>
          <li>
            If you offer services and/or products that support the yslearn
            platform, you may use the “yslearn” word mark in the path of a URL
            for your website for such services and/or products. For clarity,
            this exception applies solely to (1) the “yslearn” word mark
            and not to any other yslearn Marks and (2) use in the path of a URL;
            you may not use the “yslearn” word mark or any other yslearn Mark in
            a website domain. For example:
            <ul className="smiklearn-links-li">
              <li> yslearn.yourdomain.com</li>
              <li>www.yourdomain.com/services/yslearn</li>
            </ul>
          </li>
        </ul>
        <br />
        <h2>Specifications for Use</h2>
        <p>
          All uses of yslearn Marks must comply with the applicable  trademark
          guidelines  and also:
        </p>

        <ul>
          <li>
            <h3>Identify the yslearn marks.</h3> The above-listed yslearn Marks
            are registered by yslearn or the applicable trademark owner in a
            number of countries around the world. For the first and most
            prominent usage of the above-listed yslearn Marks in any context,
            use the symbol "®" after the yslearn Mark as a notice to third
            parties of the trademark owner’s rights in these yslearn Marks.{" "}
          </li>
          <li>
            <h3>Include a trademark attribution statement.</h3>
            If an yslearn Mark appears on your website, document, or other
            material, add the following attribution statement that identifies
            the trademark owner:
            <br />
            <br />
            <span>
              “yslearn is a registered trademarks of 11326953 Canada Inc.. All
              Rights Reserved.”
            </span>
            <br />
            <br />
            The statement must be in a legible font and size at the bottom of
            your website or the end of your advertisement or publication. If you
            are using only one or two yslearn Marks, you may shorten the
            statement to list only those Marks in use. Additionally, any use of
            the<u> yslearn</u> logos on a website must include a live link to
            the yslearn websites.
            <br />
            <h4>Use yslearn Marks only as adjectives.</h4>
            Trademarks are adjectives, and an yslearn Mark should be used only
            to describe the yslearn website, products, or services to which the
            trademark applies.
            <br />
            <h4>Use yslearn Marks less prominently than your own.</h4>
            Except where otherwise expressly permitted by yslearn, any use of an
            yslearn Mark must appear less prominent than your own product or
            service name.
          </li>
          <li>
            <h3>
              Do NOT change the spelling or appearance of any yslearn Marks.
            </h3>
            Do not abbreviate, hyphenate, create acronyms; change the spelling,
            capitalization, or appearance; add or delete any words or spacing;
            change any color or proportion; or otherwise modify the logo or
            design of an yslearn Mark in any way. Only use an approved logo
            rendition as provided by yslearn.
          </li>
          <li>
            <h3>
              Do NOT use or register a domain name with any yslearn Marks.
            </h3>
            Your domain names may not include any yslearn Marks or other words
            that are confusingly similar to an yslearn Mark. Examples of
            unacceptable domains include:
            <ul className="smiklearn-links-li">
              <li>opensmiklearn.yourdomain.org</li>
              <li> smiklearn.yourdomain.org</li>
              <li> opensmiklearnyourdomain.org</li>
              <li> yourdomain-smiklearn.com</li>
            </ul>
          </li>
          <li>
            <h3>Do NOT use any yslearn Marks as your own.</h3>
            You may not use, incorporate, combine, or register in whole or in
            part any yslearn Mark - or any word or design that is confusingly
            similar to an yslearn Mark - as part of (or with) your own company
            names, trade names, trademarks, service marks, or logos; your
            product or service brand names or titles for sales reps or other
            staff; your internet keywords or metatags; or your trigger words to
            lead to a website or other Internet destination, product, business,
            or service.
          </li>
          <li>
            <h3>Do NOT imply any yslearn endorsement or sponsorship.</h3>
            Without the express prior written consent of yslearn, you may not
            use any yslearn Marks to imply an affiliation with yslearn or any
            approval, sponsorship, or endorsement by yslearn of your company,
            website, products, or services.
          </li>
          <li>
            <h3>Do NOT use yslearn Marks in any way that damages yslearn.</h3>
            You may not use yslearn Marks in a manner that disparages yslearn,
            its products or services, or the yslearn community or damages
            yslearn’s brand integrity, including use of any yslearn Marks in a
            manner that is offensive, defamatory, illegal, or unethical.
          </li>
        </ul>

        <p>
          The above specifications are not a comprehensive list of approved or
          unauthorized uses of yslearn Marks. If yslearn determines at any time,
          in its sole discretion, that your use of any yslearn Mark violates
          this Policy, any trademark guidelines  or is otherwise unacceptable or
          detrimental, yslearn may revoke permission, and you must immediately
          cease all use of the yslearn Mark.
        </p>
      </div>
    </div>
  );
};

export default TrademarkPolicy;
